(() => {
  const setup = (root) => {
    if (root.dataset.hdvchButtonsReady === 'true') return;
    root.dataset.hdvchButtonsReady = 'true';
    const restoreDonationLabel = () => {
      const regularLabel = window.MinimogStrings?.addToCart?.trim();
      if (!regularLabel) return;
      root.querySelectorAll('button[name="add"][data-atc-text]').forEach((button) => {
        const text = button.querySelector('.m-add-to-cart--text');
        if (!button.disabled && text && text.textContent.trim() === regularLabel) {
          text.textContent = button.dataset.atcText;
        }
      });
    };
    const observer = new MutationObserver(restoreDonationLabel);
    observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled']});
    restoreDonationLabel();
  };
  const initialize = () => document.querySelectorAll('product-info.hdvch-product').forEach(setup);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
